import React from 'react';
import { ArrowLeft, Shield, Users, Globe, Award, Briefcase, Heart } from 'lucide-react';
import DoodleBackground from '../components/DoodleBackground';

const AboutUs = () => {
  return (
    <div>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        background: 'rgba(255,255,255,.97)', boxShadow: '0 2px 20px rgba(120,81,169,.08)',
        backdropFilter: 'blur(16px)', padding: '10px 0',
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none', color: 'inherit' }}>
            <img src="/logo.png" alt="Spee'V'Dee" style={{ width: 44, height: 44, borderRadius: '50%' }} />
            <span className="logo-text"><span className="bk">Spee</span><span className="vv">'V'</span><span className="bk">Dee</span></span>
          </a>
          <a href="/" className="btn btn-outline" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: '#7851A9', fontWeight: 700, fontSize: 14, textDecoration: 'none', padding: '8px 20px', borderRadius: '50px', border: '2px solid #7851A9' }}>
            <ArrowLeft size={16} /> Back to Home
          </a>
        </div>
      </nav>

      <section style={{ background: '#f9fafb', position: 'relative', overflow: 'hidden', paddingTop: 100, paddingBottom: 80 }}>
        <DoodleBackground />
        <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 1 }}>
          <div className="section-header">
            <span className="section-tag" style={{ background: 'rgba(120,81,169,.1)', color: '#7851A9' }}>ABOUT US</span>
            <h2>Our Story</h2>
          </div>

          <div style={{ background: '#fff', borderRadius: 16, padding: '40px 36px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)', fontSize: 14, lineHeight: 1.8, color: '#374151', marginBottom: 32 }}>
            <p style={{ fontSize: 16, fontWeight: 600, color: '#1F2937' }}>Spee'V'Dee was born from a simple idea: everyone is going somewhere — why not carry a package along the way?</p>
            <p>Founded by Nighteengale Group Ltd., Spee'V'Dee is a peer-to-peer delivery app that connects people who need to send packages with everyday travelers heading in the right direction. From flight attendants crossing oceans to students cycling across campus, anyone can be a courier.</p>
            <p>We believe that the future of delivery isn't more trucks and warehouses — it's the millions of people already moving through the world every day. Our app harnesses this existing movement to create faster, cheaper, and more sustainable deliveries across 195 countries.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 16, marginBottom: 32 }}>
            {[
              { icon: <Globe size={24} color="#7851A9" />, title: '195 Countries', desc: 'Global coverage from day one. Send packages anywhere in the world.' },
              { icon: <Users size={24} color="#7851A9" />, title: 'Community-Powered', desc: 'Drivers, cyclists, students, flight attendants — everyone can deliver.' },
              { icon: <Shield size={24} color="#7851A9" />, title: 'Trust & Safety', desc: 'ID verification, facial recognition, real-time tracking on every delivery.' },
              { icon: <Award size={24} color="#7851A9" />, title: '$1/Month', desc: 'Affordable for everyone. One flat subscription, no hidden fees.' },
              { icon: <Heart size={24} color="#7851A9" />, title: 'Sustainable', desc: 'Leveraging existing travel reduces carbon footprint vs. traditional logistics.' },
              { icon: <Briefcase size={24} color="#7851A9" />, title: 'Earn Extra', desc: 'Couriers earn on deliveries that fit their existing routes and schedules.' },
            ].map((item, i) => (
              <div key={i} className="bmc-feature">
                <div style={{ marginBottom: 8 }}>{item.icon}</div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>

          <div style={{ background: 'linear-gradient(135deg, #7851A9, #5B2D8E)', borderRadius: 16, padding: '36px', color: '#fff', textAlign: 'center' }}>
            <h3 style={{ color: '#fff', marginBottom: 8, fontSize: 20 }}>Nighteengale Group Ltd.</h3>
            <p style={{ color: 'rgba(255,255,255,.8)', margin: 0 }}>Parent Company of Speedy Variety Delivery (Spee'V'Dee)</p>
            <p style={{ color: 'rgba(255,255,255,.6)', fontSize: 13, marginTop: 12 }}>Contact: info@speedyvariety.com</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
